import { ProjectsOrderBy } from '../../../../server/graphql/__generated.types';
import { ProjectSortDropdownOptions } from './ProjectSortDropdown';

export const mapToDropdownOption = (order: ProjectsOrderBy) => {
  switch (order) {
    case ProjectsOrderBy.NameAsc:
      return ProjectSortDropdownOptions.NameAsc;
    case ProjectsOrderBy.NameDesc:
      return ProjectSortDropdownOptions.NameDesc;
    case ProjectsOrderBy.CreatedAtAsc:
      return ProjectSortDropdownOptions.CreatedAtAsc;
    case ProjectsOrderBy.CreatedAtDesc:
      return ProjectSortDropdownOptions.CreatedAtDesc;
    default:
      return ProjectSortDropdownOptions.CreatedAtDesc;
  }
};

export const mapToOrderModel = (option: ProjectSortDropdownOptions) => {
  switch (option) {
    case ProjectSortDropdownOptions.NameAsc:
      return ProjectsOrderBy.NameAsc;
    case ProjectSortDropdownOptions.NameDesc:
      return ProjectsOrderBy.NameDesc;
    case ProjectSortDropdownOptions.CreatedAtDesc:
      return ProjectsOrderBy.CreatedAtDesc;
    case ProjectSortDropdownOptions.CreatedAtAsc:
      return ProjectsOrderBy.CreatedAtAsc;
    default:
      return ProjectsOrderBy.CreatedAtDesc;
  }
};

/**
 * Query params are coming in as lower-case. This function will convert the query param value for orderby
 * to the @see ProjectsOrderBy enum equivalent option. We will return undefined for the sorting options
 * that are not supported on the frontend.
 */
export const queryParamToSupportedProjectsOrderBy = (
  option: string | string[] | undefined
) => {
  switch (option) {
    case ProjectsOrderBy.NameAsc.toString().toLowerCase():
      return ProjectsOrderBy.NameAsc;

    case ProjectsOrderBy.NameDesc.toString().toLowerCase():
      return ProjectsOrderBy.NameDesc;

    case ProjectsOrderBy.CreatedAtDesc.toString().toLowerCase():
      return ProjectsOrderBy.CreatedAtDesc;

    case ProjectsOrderBy.CreatedAtAsc.toString().toLowerCase():
      return ProjectsOrderBy.CreatedAtAsc;

    default:
      return undefined;
  }
};

export default {
  mapToDropdownOption,
  mapToOrderModel,
};
